import React from 'react'
import { injectIntl } from 'react-intl'

function Page404 (props) {
  return (<span>{props.intl.formatMessage({ id: '404.notFound' })}</span>)
}

export default injectIntl(Page404)
